var _path, _path2, _polygon, _polygon2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C21325",
    stroke: "#FFF",
    strokeWidth: 20,
    d: "M 465.391 381.102 C 464.851 381.43 447.042 378.442 424.726 376.931 C 406.501 375.696 385.27 375.743 367.982 376.914 C 353.963 377.863 335.544 370.816 333.343 379.191 C 325.105 410.542 307.38 437.846 284.832 459.119 C 267.869 475.122 248.455 487.257 227.457 494.734 C 202.458 481.892 190.652 453.33 201.305 428.287 C 209.754 408.424 219.585 386.547 201.435 381.542 C 188.222 377.898 180.967 390.555 175.888 404.087 C 166.158 430.01 147.669 456.835 142.4 488.608 C 136.838 522.15 142.382 557.755 171.392 577.861 C 238.954 624.687 312.292 548.833 389.617 529.765 C 417.641 522.854 448.402 523.968 473.092 509.668 C 491.633 498.929 503.856 481.133 507.325 461.152 C 512.905 429.015 496.186 397.086 465.391 381.102 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 20,
    d: "M333.343,379.191c-8.238,31.351-25.963,58.655-48.511,79.928 c-16.963,16.003-36.377,28.138-57.376,35.615c-24.999-12.842-36.805-41.404-26.152-66.447c8.449-19.863,18.28-41.74,0.13-46.745 c-13.213-3.644-20.468,9.013-25.547,22.545c-9.73,25.923-28.219,52.748-33.488,84.521c-5.562,33.542-0.018,69.147,28.992,89.253 c67.562,46.826,140.9-29.028,218.226-48.096c28.024-6.911,58.785-5.797,83.475-20.097c18.541-10.739,30.764-28.535,34.233-48.515 c5.58-32.137-11.139-64.066-41.934-80.05"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C21325",
    points: "395.364 254.17 449.685 364.982 514.778 173 275.789 173 340.732 364.641"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 20,
    points: "395.364 254.17 449.685 364.982 514.777 173 275.789 173 340.732 364.641"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 329.46,
    cy: 379.583,
    r: 40.945,
    fill: "#C21325"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.46,
    cy: 379.583,
    r: 40.945,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 20
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.844,
    cy: 379.583,
    r: 40.945,
    fill: "#C21325",
    stroke: "#FFF",
    strokeWidth: 20
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.844,
    cy: 379.583,
    r: 40.945,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 20
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.571,
    cy: 379.877,
    r: 40.945,
    fill: "#C21325"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.571,
    cy: 379.877,
    r: 40.945,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 20
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJest);
export default __webpack_public_path__ + "static/media/jest.68ba5aedf2e8f5295759f3a09c0a1de3.svg";
export { ForwardRef as ReactComponent };